export default "__VITE_ASSET__DERYjctO__"